import { Injectable } from '@angular/core';

import { Specification } from '../definition/specification';
import { LoggedUserModel } from 'app/models/auth/auth.model';

@Injectable()
export class AppAccessPermissionSpec extends Specification<LoggedUserModel> {
	// skipcq: JS-0105
  IsSatisfiedBy(candidate?: LoggedUserModel | null): boolean {
    return Boolean(candidate);
	}
}
